<template>
	<div>
		<addedtax ref="addedtax" v-show="type == 'addedtax'"></addedtax>
	</div>
</template>
<script>
import addedtax from '@/components/baseinfo/addedtax.vue'; //增值税
export default {
	components: {
		addedtax
	},
	props: {
		urlparam: {
			type: Object,
			default: {}
		}
	},
	data() {
		return {
			pageparam: {},
			id: '',
			iscopy: 0,
			type: ''
		};
	},
	mounted() {
		//console.log('urlparam',this.urlparam);
		if (this.urlparam != undefined) {
			this.pageparam = this.urlparam;
			if (this.urlparam.id != undefined) {
				this.id = this.urlparam.id;
				if (this.urlparam.iscopy != undefined) {
					this.iscopy = this.urlparam.iscopy;
				}
			}
			if(this.urlparam.l_tablename!=undefined)
				this.type=this.urlparam.l_tablename;
			if(this.type=='') this.type='default';
			if (this.type == 'addedtax') {
				if (this.$refs.addedtax != undefined) {
					this.$refs.addedtax.init({id:this.id,iscopy:this.iscopy});
				}
			}
		}
	}
};
</script>
